const MDAllyInsights = (function($){
	let page_num = 0;
	let category = "";
	let tags = "";
	let sort_order = "";
	let isLoading = false;
	
    const onInit = function(){
		jQuery('body').css('opacity', 1);

		jQuery('.categories .button').on("click", function(e){
			e.preventDefault();
			
			jQuery('#ajax-insights #category').val(jQuery(this).data("category"));
			jQuery('#ajax-insights #page').val(1);
			jQuery('.categories .button').removeClass("is-style-red-fill-button")
			jQuery(this).addClass("is-style-red-fill-button");
			clearItems();
			loadItems();
		});

		jQuery('.categories-mobile .button').on("click", function(e){
			e.preventDefault(); 
			
			jQuery('#ajax-insights #category').val(jQuery(this).data("category"));
			jQuery('#ajax-insights #page').val(1);
			jQuery('.categories-mobile .button').removeClass("is-style-red-fill-button")
			jQuery(this).addClass("is-style-red-fill-button");
			clearItems();
			loadItems();
			var sections = jQuery('.filter-accordion').find(".filter-accordion-item.is-active .accordion-content");
    		sections.each(function (i, section) {
				jQuery('.filter-accordion').foundation("up", $(section));
    		});
			
			jQuery('.clear-category').remove();
			if(jQuery(this).text() != "All"){
				jQuery('.left-side').append('<a href="#" rel="tag"  class="button btn is-style-outline tag-button clear-category">'+jQuery(this).text()+' <img src="/wp-content/themes/mdally/assets/images/tag-remove.svg" alt=""/></a>');
			}
		});
		
		
		jQuery('body').on("click", '.clear-category', function(e){
			e.preventDefault();
			jQuery('.all-categories-button').trigger("click");
		});

		jQuery('.clear-tag').on("click", function(e){
			e.preventDefault();
			
			jQuery('#ajax-insights #page').val(1);
			jQuery('#ajax-insights #tags').val("");
			jQuery(this).remove();
			clearItems();
			loadItems();
		});

		
		
		jQuery('#sort-by').on("change", function(e){
			page_num = 1;
			jQuery('#ajax-insights #page').val(page_num);
			clearItems();
			loadItems();
		});
		
		jQuery(window).scroll((e)=>{
    		const div = jQuery('.insight-items');
		    if(!isLoading && jQuery(window).scrollTop() >= div.offset().top + div.outerHeight() - window.innerHeight) {
				console.log('----- end reached ------');

				page_num = parseInt(jQuery('#ajax-insights #page').val()) || 1;
				if(jQuery('.insight-items').data("post-count") >= page_num*9){
					page_num++;
					jQuery('#ajax-insights #page').val(page_num);
					loadItems();
				}
		    }
		});
    	
    }
	
	function loadItems(){
		page_num = jQuery('#ajax-insights #page').val();
		tags = jQuery('#ajax-insights #tags').val();
		category = jQuery('#ajax-insights #category').val();
		sort_order = jQuery('#sort-by').val();
		
		isLoading = true;
		$('.insights-loading').show();
		
		jQuery.ajax({           
			url : mdAlly.adminAjax,
			type : 'post',
			dataType: "json",
			data : {
				action: 'insights',
				category: category,
				sort: sort_order,
				tag: tags,
				paged: page_num
			},
			success: function(response){
				jQuery('.insight-items').append(response.contents).data("post-count", response.count);
				jQuery('.insights-list h5').html(response.count+" Results");
				$('.insights-loading').hide();
				isLoading = false;
			}
		});
	}
	
	function clearItems(){
		jQuery('.insight-items').html("");
	}
	
    return{
    	init: onInit,
    }; 

})(jQuery);
